var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "icon-packs" } }, [
    _c(
      "div",
      { staticClass: "row roomy" },
      _vm._l(_vm.iconPacks, function (pack) {
        return _c(
          "div",
          {
            key: pack.name,
            staticClass:
              "all-icon-packs-listing column-12 tablet:column-6 laptop:column-4",
            staticStyle: {
              "--card-min-height": "var(--icon-pack-card-min-height, 12rem)",
            },
          },
          [
            _c(
              "site-link",
              {
                class: `card header icon-pack-card icon-pack-card-${pack.name}`,
                style: `
          background-clip: padding-box;
          background-image: url('/images/icons/packs/${pack.name}/${pack.thumbImage}');
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        `,
                attrs: { to: _vm.$pack({ name: pack.name }) },
              },
              [
                _c("span", { staticClass: "sr-only" }, [
                  _vm._v(_vm._s(pack.label)),
                ]),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }